(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo_carousel"] && !Shopify.designMode) return;
  try {
    
  class CmLogoCarousel extends HTMLElement {
    constructor() {
      super();
      this.pos = 0;
      this.velocity = 0;
      this.groupWidth = 0;
      this.gap = 0;
      this.running = false;
      this.dragging = false;
      this.hovering = false;
      this.visible = true;
      this.pointerId = null;
      this.moved = 0;
      this.samples = [];
      this.lastTime = 0;
      this.rafId = null;
      this.suppressClick = false;
      this.wheelIdle = 0;

      this.onFrame = this.onFrame.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onPointerCancel = this.onPointerCancel.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);
      this.onWheel = this.onWheel.bind(this);
      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('.cm-logos__viewport');
      this.track = this.querySelector('.cm-logos__track');
      this.master = this.track && this.track.firstElementChild;
      if (!this.viewport || !this.track || !this.master) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = parseFloat(this.dataset.speed) || 0;
      this.dirSign = this.dataset.direction === 'right' ? -1 : 1;
      this.autoplay = this.dataset.autoplay === 'true';
      this.dragEnabled = this.dataset.drag === 'true';
      this.wheelEnabled = this.dataset.wheel === 'true';
      this.hoverFactor = Math.min(Math.max(parseFloat(this.dataset.hoverSpeed) || 0, 0), 100) / 100;

      this.measure();
      this.bind();
      this.render();
      this.wake();
    }

    disconnectedCallback() {
      this.stop();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    bind() {
      // Interaction is bound to the host element, not to the logo strip, so the
      // padding and the headline area are draggable too.
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointermove', this.onPointerMove);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerCancel);
      this.addEventListener('click', this.onClickCapture, true);
      this.addEventListener('dragstart', (e) => e.preventDefault());
      this.addEventListener('wheel', this.onWheel, { passive: false });
      this.addEventListener('pointerenter', this.onEnter);
      this.addEventListener('pointerleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      document.addEventListener('visibilitychange', this.onVisibility);

      if ('ResizeObserver' in window) {
        // Observing the master group only: clones never change its width, so no feedback loop.
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.master);
        this.resizeObserver.observe(this.viewport);
      }

      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.visible ? this.wake() : this.stop();
        }, { rootMargin: '100px' });
        this.intersectionObserver.observe(this);
      }
    }

    measure() {
      const width = this.master.getBoundingClientRect().width;
      if (!width) return;
      this.gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.groupWidth = width + this.gap;
      this.fill();
      this.wrap();
      this.render();
    }

    fill() {
      const viewportWidth = this.viewport.getBoundingClientRect().width;
      const needed = Math.max(2, Math.ceil(viewportWidth / this.groupWidth) + 1);
      const current = this.track.children.length;

      if (current < needed) {
        const frag = document.createDocumentFragment();
        for (let i = current; i < needed; i++) frag.appendChild(this.makeClone());
        this.track.appendChild(frag);
      } else {
        while (this.track.children.length > needed) this.track.lastElementChild.remove();
      }
    }

    makeClone() {
      const clone = this.master.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
        el.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('a').forEach((el) => el.setAttribute('tabindex', '-1'));
      return clone;
    }

    targetVelocity() {
      if (!this.autoplay || this.reduced.matches || !this.speed) return 0;
      return this.speed * this.dirSign * (this.hovering ? this.hoverFactor : 1);
    }

    wake() {
      if (this.running || !this.visible) return;
      this.running = true;
      this.lastTime = 0;
      this.rafId = requestAnimationFrame(this.onFrame);
    }

    stop() {
      this.running = false;
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    onFrame(now) {
      if (!this.running) return;
      const dt = this.lastTime ? Math.min((now - this.lastTime) / 1000, 0.064) : 0;
      this.lastTime = now;

      if (!this.dragging && dt > 0) {
        // During a wheel gesture the OS already drives the position through its own
        // inertia, so integrating velocity on top of it would add drift.
        if (now < this.wheelIdle) {
          this.rafId = requestAnimationFrame(this.onFrame);
          return;
        }

        const target = this.targetVelocity();
        // Exponential smoothing handles both the hover ramp and the post-flick decay.
        this.velocity += (target - this.velocity) * (1 - Math.exp(-dt / 0.35));

        if (target === 0 && Math.abs(this.velocity) < 0.05) {
          this.velocity = 0;
          this.stop();
          return;
        }

        this.pos += this.velocity * dt;
        this.wrap();
        this.render();
      }

      this.rafId = requestAnimationFrame(this.onFrame);
    }

    wrap() {
      const g = this.groupWidth;
      if (!g) return;
      this.pos = ((this.pos % g) + g) % g;
    }

    render() {
      this.track.style.transform = 'translate3d(' + -this.pos + 'px, 0, 0)';
    }

    onEnter(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      this.hovering = true;
      this.wake();
    }

    onLeave(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      this.hovering = false;
      this.wake();
    }

    onVisibility() {
      document.hidden ? this.stop() : this.wake();
    }

    onPointerDown(e) {
      if (!this.dragEnabled) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      this.dragging = true;
      this.pointerId = e.pointerId;
      this.moved = 0;
      this.suppressClick = false;
      this.lastX = e.clientX;
      this.velocity = 0;
      this.samples = [{ x: e.clientX, t: performance.now() }];
      this.classList.add('is-dragging');
      try { this.setPointerCapture(e.pointerId); } catch (err) {}
    }

    onPointerMove(e) {
      if (!this.dragging || e.pointerId !== this.pointerId) return;
      const dx = e.clientX - this.lastX;
      this.lastX = e.clientX;
      this.moved += Math.abs(dx);
      this.pos -= dx;
      this.wrap();
      this.render();
      this.samples.push({ x: e.clientX, t: performance.now() });
      if (this.samples.length > 6) this.samples.shift();
    }

    onPointerUp(e) {
      if (!this.dragging || e.pointerId !== this.pointerId) return;
      this.endDrag(e);

      const now = performance.now();
      const first = this.samples.find((s) => now - s.t < 120) || this.samples[0];
      const elapsed = (now - first.t) / 1000;
      const flick = elapsed > 0.008 ? -(e.clientX - first.x) / elapsed : 0;
      this.velocity = Math.max(-4000, Math.min(4000, flick));
      this.suppressClick = this.moved > 10;
      this.wake();
    }

    onPointerCancel(e) {
      if (!this.dragging || e.pointerId !== this.pointerId) return;
      // The browser took over the gesture (vertical page scroll): no flick.
      this.endDrag(e);
      this.velocity = 0;
      this.suppressClick = this.moved > 10;
      this.wake();
    }

    endDrag(e) {
      this.dragging = false;
      this.pointerId = null;
      this.classList.remove('is-dragging');
      try { this.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    onClickCapture(e) {
      if (!this.suppressClick) return;
      this.suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }

    normalizeDelta(value, mode) {
      if (mode === 1) return value * 16;
      if (mode === 2) return value * this.viewport.getBoundingClientRect().width;
      return value;
    }

    onWheel(e) {
      if (!this.wheelEnabled) return;

      const dy = this.normalizeDelta(e.deltaY, e.deltaMode);
      let dx = this.normalizeDelta(e.deltaX, e.deltaMode);
      // Some browsers do not remap shift + wheel onto deltaX
      if (e.shiftKey && dx === 0) dx = dy;

      // Vertical intent stays with the page
      if (Math.abs(dx) <= Math.abs(dy)) return;

      e.preventDefault();
      this.pos += dx;
      this.wrap();
      this.render();
      this.velocity = 0;
      this.wheelIdle = performance.now() + 90;
      this.wake();
    }
  }

  if (!customElements.get('cm-logo-carousel')) {
    customElements.define('cm-logo-carousel', CmLogoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
